
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'

function Contactus() {
        const [pageTitle,setPageTitle] = useState('About Us');
        const [pageContent,setPageContent] = useState('');
      

    useEffect(() => {
            getData()
        }, []);
    
        const getData = async () => {
            try {
                const response = await fetch('https://api.kahaaniplus.com/api/v1/page/contact-us');
                const data = await response.json();
                setPageTitle(data.data.page_title);
                setPageContent(data.data.page_content);
                console.log(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };


    return (
        <Container className='mt-5'>
            <h1 className='text-center'>{pageTitle}</h1>
            <p className='my-para' dangerouslySetInnerHTML={{ __html: pageContent }}>
               {/*  <b>Merchant Legal entity name: </b> TIARA DIGITAL SERVICES PRIVATE LIMITED<br/>
                <b>Operational Address </b>: 1st Avenue, 10th Floor Near Inorbit Mall, Goregaon-Mulund Link Road, Malad, MUMBAI, Maharashtra, PIN: 400064 <br/>
                <b>Telephone No:</b> 9867893783 <br/>
                <b>E-Mail ID: </b>contactus@tiaradigital.in
                */}
            </p>
        </Container>
    )
}

export default Contactus